import { combineLatest } from 'rxjs'
import { take } from 'rxjs/operators'
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { Destroyable, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { SystemNotificationsOverlayService } from '@tv3/layout/system-notifications-overlay/system-notifications-overlay.service'
import { select, Store } from '@ngrx/store'
import { LoadNotificationUnreadCount } from '@tv3/store/notification/notification.actions'
import {
  selectNotificationUnreadCount,
  selectNotificationUnreadCountLoaded,
  selectNotificationUnreadCountLoading,
} from '@tv3/store/notification/notification.selectors'

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotificationsComponent extends Destroyable implements OnInit {
  unreadCount = 0

  constructor(private store: Store<any>, private systemNotificationsOverlayService: SystemNotificationsOverlayService) {
    super()
  }

  ngOnInit() {
    // Only load unread count if not already loaded or loading
    combineLatest([
      this.store.pipe(select(selectNotificationUnreadCountLoaded)),
      this.store.pipe(select(selectNotificationUnreadCountLoading)),
    ])
      .pipe(take(1))
      .subscribe(([isLoaded, isLoading]) => {
        if (!isLoaded && !isLoading) {
          this.store.dispatch(LoadNotificationUnreadCount())
        }
      })

    this.store.pipe(select(selectNotificationUnreadCount), untilDestroy(this)).subscribe((count) => {
      this.unreadCount = count
    })
  }

  onShown() {
    this.systemNotificationsOverlayService.open().afterClosed().subscribe()
  }
}
